import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "https://azmrehabcentre.pk/api/public";
// const API_URL = "http://127.0.0.1:8000/";


const signUp = async (values) => {
    try {
      const headers = {
        'Content-Type': 'application/json',
      };
      const response = await axios.post(`${API_URL}/subscribe`, { email: values.email }, { headers });
      return response.data; // Return the response data
    } catch (error) {
      throw new Error('Failed to sign up'); // Throw an error to be caught in onSubmit
    }
  };
  const contactMessage = async (values) => {
    try {
      const headers = {
        'Content-Type': 'application/json',
      };
      const response = await axios.post(`${API_URL}/contact-message`, values, { headers });
      return response.data;
    } catch (error) {
      throw new Error('Failed to send message');
    }
  };

  const makeAppointment = async (values) => {
    try {
      const headers = {
        'Content-Type': 'application/json',
      };
      const response = await axios.post(`${API_URL}/make-appointment`, values, { headers });
      return response.data;
      // fdfdf
    } catch (error) {
      throw new Error('Failed to make Appointment');
    }
    // testing
  };

  const getDoctors = async () => {
    try {
      const headers = {
        'Content-Type': 'application/json',
      };
      const response = await axios.get(`${API_URL}/doctors`, { headers });
      return response.data;
    } catch (error) {
      throw new Error('Failed to fetch doctors');
    }
  };

  const getStaffs = async () => {
    try {
      const headers = {
        'Content-Type': 'application/json',
      };
      const response = await axios.get(`${API_URL}/staff`, { headers });
      return response.data;
    } catch (error) {
      throw new Error('Failed to fetch staffs');
    }
  };
  

  
const getOpeningHours = async () => {
  try {
    const headers = {
      'Content-Type': 'application/json',
    };
    const response = await axios.get(`${API_URL}/hour`, { headers });
    return response.data;
  } catch (error) {
    throw new Error('Failed to fetch opening hours');
  }
};

const sendNotification = async (appointmentId, type = 'test') => {
    try {
        const headers = {
            "Content-Type": "application/json",
        };
        
        console.log('Sending notification with appointment ID:', appointmentId, 'Type:', type);
        
        const response = await axios.post(
            `${API_URL}/send`,
            {
                appointment_id: parseInt(appointmentId), // Use appointment_id instead of user_id
                type: type
            },
            {
                headers: headers,
            }
        );
        
        console.log('Notification sent successfully:', response.data);
        return response;
        
    } catch (error) {
        console.error('Notification error:', error.response?.data || error);
        throw error;
    }
};
const GeneralService = {
    signUp,
    contactMessage,
    makeAppointment,
    getDoctors,
    getStaffs,
    getOpeningHours,
    sendNotification
};

export default GeneralService;
